import actions from '../../../actions'

export default {
  header: [
    { ...actions.addNewTerminal, create: true }
  ],
  table: {
    noApi: true,
    sorting: {
      sortBy: 'id',
      sortDesc: true
    },
    parameters: [
      { name: 'id', text: 'Nr pozycji', value: 'id', show: true },
      { name: 'createdAt', text: 'Data utworzenia', value: 'createdAt', show: true },
      { name: 'name', text: 'Nazwa terminala', value: 'name', show: true },
      { name: 'imei', text: 'Nr IMEI', value: 'imei', show: true },
      { name: 'phoneNumber', text: 'Numer telefonu', value: 'phoneNumber', show: true },
      { name: 'active', text: 'Aktywny', value: 'active', show: true },
      { name: 'actions', text: '', value: 'actions', sortable: false, show: true }
    ],
    actions: [
      { ...actions.deleteTerminal, icon: 'usun' }
    ],
    menu: [
      { ...actions.deleteTerminal }
    ]
  },
  details: {
    title: 'Terminal: {{name}}',
    actions: [
      { ...actions.deleteTerminal, redirect: true }
    ],
    sections: [
      {
        name: 'general',
        text: 'Informacje ogólne',
        type: 'left',
        endpoint: 'terminals',
        fields: [
          { name: 'id', text: 'Nr pozycji', value: 'id', type: 'textField', col: 3 },
          { name: 'createdAt', text: 'Data utworzenia', value: 'createdAt', type: 'textField', col: 3 },
          { name: 'name', text: 'Nazwa terminala', value: 'name', type: 'textField', col: 3, editable: true, rules: ['required'] },
          { name: 'imei', text: 'Nr IMEI', value: 'imei', type: 'textField', col: 3, editable: true },
          { name: 'phoneNumber', text: 'Numer telefonu', value: 'phoneNumber', type: 'textField', col: 3, editable: true, rules: ['phoneNumber'] },
          { name: 'active', text: 'Aktywny', value: 'active', type: 'boolean', col: 3, editable: true, rules: ['required'] }
        ]
      }
    ]
  }
}
